import { render } from "./headerSkeleton.vue?vue&type=template&id=6f75cdd2&xmlns%3Askeleton-item=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./headerSkeleton.vue?vue&type=script&lang=js"
export * from "./headerSkeleton.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./headerSkeleton.vue?vue&type=style&index=0&id=6f75cdd2&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__